module.exports = __webpack_public_path__ + "6fc097d5afc4c7d3cda4901d46fe4b8e.svg";